import { ApiProperty } from "@nestjs/swagger";

export class UpdateChecklist {
    @ApiProperty()
    assetServiceChecklistId: number;

    @ApiProperty()
    checklistItem: string | null;

    @ApiProperty()
    assetName: string | null;

    @ApiProperty()
    condition: string | null;

    @ApiProperty()
    reason: string | null;

    @ApiProperty()
    checklistStatus: string | null;

    @ApiProperty()
    assetServeId: number;

    @ApiProperty()
    status:string | null;


}



export class ChecklistItem {

    @ApiProperty()
    checklistItem: string | null;

    @ApiProperty()
    checklistStatus: string | null;

    @ApiProperty()
    assetServeId: number;

    @ApiProperty()
    isChecked: any;

}